module.exports = __webpack_public_path__ + "img/cooperative0_logo32.a9198c9d.jpg";